var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "TooltipTemplate",
    {
      scopedSlots: _vm._u([
        {
          key: "hover-content",
          fn: function() {
            return [
              _c("div", { staticClass: "gds-font-demi gds-space-stack-m" }, [
                _vm._v(_vm._s(_vm.tooltipDate))
              ]),
              _vm._v(" "),
              _vm._l(_vm.status.dailyStatuses, function(dailyStatus, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass:
                      "gds-flex-container gds-flex-container--left gds-flex-container--top gds-font-book gds-font-size-m gds-space-stack-s"
                  },
                  [
                    dailyStatus.key ===
                    _vm.STATUS_HISTORY_KEYS.PARTICIPATED_ENERGY_EVENT
                      ? _c("img", {
                          staticClass:
                            "gds-icon gds-font-size-l gds-space-inline-m devices-color-to-white",
                          attrs: {
                            src:
                              "/wp-content/themes/gmptwentynineteen/assets/images/devices/icon-devices-status-peak-event.svg",
                            alt: "White leaf"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    dailyStatus.key ===
                    _vm.STATUS_HISTORY_KEYS.OPTEDOUT_ENERGY_EVENT
                      ? _c("img", {
                          staticClass:
                            "gds-icon gds-font-size-l gds-space-inline-m devices-color-to-white",
                          attrs: {
                            src:
                              "/wp-content/themes/gmptwentynineteen/assets/images/devices/icon-device-peak-event-opt-out-sm-dimmed.svg",
                            alt: "White leaf with minus sign"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    dailyStatus.key === _vm.STATUS_HISTORY_KEYS.CONNECTION_OK ||
                    dailyStatus.key === _vm.STATUS_HISTORY_KEYS.DEVICE_OFFLINE
                      ? _c("img", {
                          staticClass:
                            "gds-icon gds-font-size-l gds-space-inline-m devices-color-to-white",
                          attrs: {
                            src:
                              "/wp-content/themes/gmptwentynineteen/assets/images/devices/icon-device-status-connection.svg",
                            alt: "White WiFi symbol with full bars"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    dailyStatus.key ===
                    _vm.STATUS_HISTORY_KEYS.PARTICIPATED_ENERGY_EVENT
                      ? _c("span", [_vm._v("Participated in 1 Energy Event")])
                      : _vm._e(),
                    _vm._v(" "),
                    dailyStatus.key ===
                    _vm.STATUS_HISTORY_KEYS.OPTEDOUT_ENERGY_EVENT
                      ? _c("span", [_vm._v("Opted out of 1 Energy Event")])
                      : _vm._e(),
                    _vm._v(" "),
                    dailyStatus.key === _vm.STATUS_HISTORY_KEYS.CONNECTION_OK
                      ? _c("span", [_vm._v("Connection OK")])
                      : _vm._e(),
                    _vm._v(" "),
                    dailyStatus.key === _vm.STATUS_HISTORY_KEYS.DEVICE_OFFLINE
                      ? _c("span", [_vm._v("Device Offline")])
                      : _vm._e()
                  ]
                )
              })
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c("section", { staticClass: "device-daily-status-card" }, [
        _c("div", { staticClass: "device-daily-status-card__date-container" }, [
          _c("span", { staticClass: "date" }, [
            _vm._v(_vm._s(_vm.abbreviatedDate))
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "day-of-week" }, [
            _vm._v(_vm._s(_vm.dayOfWeek))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "device-daily-status-card__icon-container" }, [
          _vm.status.dailyOverallKey === _vm.STATUS_HISTORY_KEYS.CONNECTION_OK
            ? _c("img", {
                staticClass: "devices-icon-size-m",
                attrs: {
                  src:
                    "/wp-content/themes/gmptwentynineteen/assets/images/devices/icon-devices-status-check-normal-green.svg",
                  alt: "Green check mark"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.status.dailyOverallKey === _vm.STATUS_HISTORY_KEYS.DEVICE_OFFLINE
            ? _c("img", {
                staticClass: "devices-icon-size-m",
                attrs: {
                  src:
                    "/wp-content/themes/gmptwentynineteen/assets/images/devices/icon-devices-status-issue.svg",
                  alt: "White exclamation point in orange triangle"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.status.dailyOverallKey ===
          _vm.STATUS_HISTORY_KEYS.PARTICIPATED_ENERGY_EVENT
            ? _c("img", {
                staticClass: "devices-icon-size-m",
                attrs: {
                  src:
                    "/wp-content/themes/gmptwentynineteen/assets/images/devices/icon-devices-status-peak-event.svg",
                  alt: "Purple leaf"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.status.dailyOverallKey ===
          _vm.STATUS_HISTORY_KEYS.OPTEDOUT_ENERGY_EVENT
            ? _c("img", {
                staticClass: "devices-icon-size-m",
                attrs: {
                  src:
                    "/wp-content/themes/gmptwentynineteen/assets/images/devices/icon-device-peak-event-opt-out-sm-dimmed.svg",
                  alt: "Grey leaf with minus sign"
                }
              })
            : _vm._e()
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }